




























import { computed, defineComponent, PropType } from "@vue/composition-api";
import { FileData } from "@scrile/api-provider/dist/api/FileProvider";
import { Message } from "@scrile/api-provider/dist/api/MessagesProvider";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import useAuthUser from "@/hooks/useAuthUser";
import useCoverThumbnail from "@/hooks/useCoverThumbnail";
import { isVideoFile } from "@/lib/fileHelpers";
import { getCost } from "@/lib/moneyHelpers";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import BaseImage from "@/components/BaseImage";
import FormatMoney from "@/components/FormatMoney";

export default defineComponent({
  name: "MessageGalleryItem",
  components: { BaseImage, BaseIcon, BaseButton, FormatMoney },
  props: {
    message: { type: Object as PropType<Message>, required: true },
    paymentPackages: { type: Array as PropType<PaymentPackage[]>, default: () => [] },
    opponentId: { type: String, required: true },
  },
  setup(props) {
    const { authUser } = useAuthUser();
    const isMultipleFiles = computed(() => props.message.attachment.length > 1);
    const isFree = computed(() => props.message.attachmentPricePackageId === "0");
    const isAuthor = computed(() => props.message.senderId === authUser.value?.id);
    const isPurchased = computed(() => {
      if (!isAuthor.value) {
        return !isFree.value && !!props.message.attachmentAvailable;
      }
      return !isFree.value && !!props.message.attachmentPurchasers?.includes(props.opponentId);
    });
    const messageCost = computed(() => {
      if (props.message.attachmentPricePackageId === "0") return 0;
      const paymentPackage = props.paymentPackages.find(item => item.id === props.message?.attachmentPricePackageId);
      if (!paymentPackage) return 0;
      return getCost(paymentPackage);
    });
    const previewFile = computed<FileData | undefined>(
      () =>
        Array.from(props.message.attachment)
          .sort((a, b) => (a.file.fileId.fileNumber < b.file.fileId.fileNumber ? -1 : 1))
          .find(file => file.publicAccess)?.file ?? props.message.attachment[0]?.file
    );
    const isVideo = computed(() => (previewFile.value ? isVideoFile(previewFile.value) : false));

    const { coverSrc } = useCoverThumbnail(previewFile);

    return {
      isFree,
      isVideo,
      isPurchased,
      isMultipleFiles,
      coverSrc,
      messageCost,
    };
  },
});
